import chatController from './chatController'

export default chatController



// WEBPACK FOOTER //
// ../src/controllers/chatController/index.js